import type { FormValues } from './';

export default (values: FormValues) => {
  const validationErrors = {};
  return validationErrors;
};
